import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import z from 'zod';
import { createRESTContract } from '../../index';
import {
  VoiceAIAgentDataSchema,
  VoiceAIFormDataSchema,
  VoiceConfigurationDataSchema,
  VoiceMetricsBackfillResponseSchema,
  VoiceMetricsBackfillSchema,
  VoiceStudioSettingsResponseSchema,
  VoiceStudioSettingsSchema,
} from './voice-ai.schema';

export const voiceAIContract = createRESTContract({
  getVoiceAIFormData: {
    method: 'GET',
    path: '/voice-ai/form-data',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_AI_CONFIGURATION_FORM],
    response: VoiceAIFormDataSchema,
  },
  submitVoiceAIConfiguration: {
    method: 'POST',
    path: '/voice-ai/submit',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_AI_CONFIGURATION_FORM],
    body: VoiceConfigurationDataSchema,
    response: z.void(),
  },
  getVoiceAIAgents: {
    method: 'GET',
    path: '/voice-ai/agent',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_AI_PREVIEW],
    response: VoiceAIAgentDataSchema,
  },
  // * Dedicated unfiltered list for the assignment picker. Sharing
  // * `getVoiceAIAgents` would narrow the picker to the agents already
  // * assigned, so an assignment could never be widened.
  getWorkspaceVoiceAIAgents: {
    method: 'GET',
    path: '/voice-ai/workspace-agent',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_STUDIO_MANAGE],
    response: VoiceAIAgentDataSchema,
  },
  getVoiceStudioSettings: {
    method: 'GET',
    path: '/voice-studio/settings',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_STUDIO_MANAGE],
    response: VoiceStudioSettingsResponseSchema,
  },
  updateVoiceStudioSettings: {
    method: 'PATCH',
    path: '/voice-studio/settings',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_STUDIO_MANAGE],
    body: VoiceStudioSettingsSchema,
    response: z.void(),
  },
  // * The `permissions` list is company-scoped and cannot express the global
  // * super-admin role, so the controller adds a manual `isUserSuperAdmin`
  // * check - the same pattern the settings actions above use.
  backfillVoiceMetrics: {
    method: 'POST',
    path: '/voice-ai/metrics/backfill',
    permissions: [PERMISSIONS.VOICE_AI.VOICE_STUDIO_MANAGE],
    body: VoiceMetricsBackfillSchema,
    response: VoiceMetricsBackfillResponseSchema,
  },
});
